import { FORMAT_GUID } from '@app/modules/core/constants/global.constants';

export function newGuid(): string {
  let d = new Date().getTime();
  let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0;
  return FORMAT_GUID.replace(/[xy]/g, (c) => {
    let r = Math.random() * 16;
    /* tslint:disable:no-bitwise */
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    /* tslint:enable:no-bitwise */
  });
}

